import { useState } from "react";
import "./styles.scss";
import { PopupContainer } from "../../../components/popup";
import { Button, Stack } from "@mui/material";
import { DesignerWelcomePopupPageOne } from "./popup-page-1";
import { useNavigate } from "react-router";
import { DesignerWelcomePopupPageTwo } from "./popup-page-2";

export const DesignerWelcomePopup = () => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);
  const [page, setPage] = useState(0);

  if (dismissed) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
  };

  const handleStartApplication = () => {
    navigate("/designer-application");
  };

  return (
    <PopupContainer
      className="designer-welcome-popup"
      title={
        page === 0
          ? "We are happy you're here!"
          : "Application Process Overview"
      }
      onClose={handleDismiss}
      maxWidth={560}
    >
      {page === 0 && <DesignerWelcomePopupPageOne />}

      {page === 1 && <DesignerWelcomePopupPageTwo />}

      <Stack
        className="designer-welcome-popup-actions"
        direction="row"
        alignItems={"center"}
        justifyContent="space-between"
      >
        <Button
          className="designer-welcome-popup-button designer-welcome-popup-button--secondary"
          variant="outlined"
          onClick={() => {
            handleDismiss();
          }}
        >
          Cancel
        </Button>

        <Button
          className="designer-welcome-popup-button designer-welcome-popup-button--primary"
          variant="contained"
          onClick={() => {
            if (page === 0) {
              setPage(1);
            } else {
              handleStartApplication();
            }
          }}
        >
          {page === 0 ? "Continue" : "Start Application"}
        </Button>
      </Stack>
    </PopupContainer>
  );
};
